import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import invariant from 'invariant';
import classNames from 'classnames';
import BreakpointHelper from './BreakpointHelper';
import breakpoints from './grid/constants';

const SHOW = 'show';
const HIDE = 'hide';

// bpStringRegExp looks like this: /^(xs |sm |md |lg |xl )+$/
const bpStringRegExp = new RegExp(
  `^(${Object.keys(breakpoints)
    .map((bp) => `${bp} `)
    .join('|')})+$`,
);
const bpStringPropType = (props = {}, propName, componentName) => {
  invariant(
    !props[propName] || bpStringRegExp.test(`${props[propName]} `),
    'Invalid prop `%s` with value `%s` supplied to `%s`, expected a breakpoint string, i.e. "xs md lg".',
    propName,
    props[propName],
    componentName,
  );
};

export default class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: !!(props.hide || props.show),
    };
    this.onHideChange = this.onChange.bind(this, HIDE);
    this.onShowChange = this.onChange.bind(this, SHOW);
  }

  UNSAFE_componentWillMount() {
    const { show, hide } = this.props;
    if (BreakpointHelper.supported() && (hide || show)) {
      if (hide) {
        BreakpointHelper.on(hide, this.onHideChange);
      }
      if (show) {
        BreakpointHelper.on(show, this.onShowChange);
      }
      this.setState({
        isVisible: hide ? !BreakpointHelper.matches(hide) : BreakpointHelper.matches(show),
      });
    }
  }

  componentWillUnmount() {
    if (BreakpointHelper.supported()) {
      BreakpointHelper.off(this.onHideChange);
      BreakpointHelper.off(this.onShowChange);
    }
  }

  onChange(display, matches) {
    const isVisible = (display === SHOW && matches) || (display === HIDE && !matches);
    this.setState({ isVisible });
  }

  getShowHideClassName() {
    return ['hide', 'show'].reduce((classes, prefix) => {
      const bpString = this.props[prefix];
      const newClasses = bpString ? bpString.split(' ').map((bp) => `${prefix}-${bp}`) : [];
      return [...classes, ...newClasses];
    }, []);
  }

  shouldRenderContent() {
    const childCount = React.Children.count(this.props.children);
    return childCount && this.state.isVisible;
  }

  render() {
    if (this.shouldRenderContent()) {
      const compProps = _.omit(this.props, ['hide', 'show', 'tagName', 'className', 'children']);
      return React.createElement(
        this.props.tagName,
        {
          ...compProps,
          className: classNames(this.getShowHideClassName(), this.props.className),
        },
        this.props.children,
      );
    }
    return null;
  }
}

Toggle.propTypes = {
  hide: bpStringPropType,
  show: bpStringPropType,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Toggle.defaultProps = {
  tagName: 'span',
  className: '',
};
